import { useMemo, useState, useEffect } from "react";

export function useStoredBoxContent(boxContentInitial) {
  const intitialState = useMemo(() => {
    const localStorageContent = localStorage.getItem("boxContentStorage");
    if (localStorageContent) {
      return JSON.parse(localStorageContent);
    }
    return boxContentInitial;
  }, []);

  const [storeBoxContent, setStoreBoxContent] = useState(intitialState);

  useEffect(() => {
    const storeState = JSON.stringify(storeBoxContent);
    localStorage.setItem("boxContentStorage", storeState);
  }, [storeBoxContent]);

  return [storeBoxContent, setStoreBoxContent];
}

export function useStoredHistory(boxHistory) {
  const initialState = useMemo(() => {
    const localStorageHistory = localStorage.getItem("historyStorage");
    if (localStorageHistory) {
      return JSON.parse(localStorageHistory);
    }
    return boxHistory;
  }, []);

  const [storedHistory, setStoredHistory] = useState(initialState);

  useEffect(() => {
    const storeHistory = JSON.stringify(storedHistory);
    localStorage.setItem("historyStorage", storeHistory);
  }, [storedHistory]);

  return [storedHistory, setStoredHistory];
}
// style history for undo
export function useStoredStyleHistory(boxHistory) {
  const initialState = useMemo(() => {
    const localStorageHistory = localStorage.getItem("styleHistoryStorage");
    if (localStorageHistory) {
      return JSON.parse(localStorageHistory);
    }
    return boxHistory;
  }, []);

  const [storedHistory, setStoredHistory] = useState(initialState);

  useEffect(() => {
    const storeHistory = JSON.stringify(storedHistory);
    localStorage.setItem("styleHistoryStorage", storeHistory);
  }, [storedHistory]);

  return [storedHistory, setStoredHistory];
}



export function useStoredMoves(moves) {
  const initialState = useMemo(() => {
    const localStorageMoves = localStorage.getItem("movesStorage");
    if (localStorageMoves) {
      return JSON.parse(localStorageMoves);
    }
    return moves;
  }, []);

  const [storedMoves, setStoredMoves] = useState(initialState);

  useEffect(() => {
    const storeMoves = JSON.stringify(storedMoves);
    localStorage.setItem("movesStorage", storeMoves);
  }, [storedMoves]);

  return [storedMoves, setStoredMoves];
}

// export function useStoredRef(historyRef){
//    const initialRef = useMemo(() => {
//      const localStorageHistoryRef = localStorage.getItem("HistoryRef");
//      if (localStorageHistoryRef) {
//        return JSON.parse(localStorageHistoryRef);
//      }
//      return historyRef;
//    }, []);
//   const historyReference = useRef(initialRef);

//   useEffect(() => {
//     const storeHistory = JSON.stringify(historyReference);
//     localStorage.setItem("HistoryRef", storeMoves);
//   }, [historyReference]);
//   return historyReference.current
// }

export function useStoredState(liveState, storageId){
  const initialState = useMemo(() => {

    const localStorageState = localStorage.getItem(storageId);
    try{
      if(localStorageState !== null){
            return JSON.parse(localStorageState);
          }
          // lazy initializer, accepting functions as arguments. 
          return typeof liveState === "function" ? liveState() : liveState;
    } catch (error){
      console.log(error);
    }
    
    //return liveState;
  }, [storageId]);

  const [myState, setMyState ] = useState(initialState);

  useEffect(() => {
    const storeState = JSON.stringify(myState);
    localStorage.setItem(storageId, storeState);
  }, [myState, storageId]);

  return [myState, setMyState];
}
